import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { REGEXPS } from '@/common';
import { API_URL, IAggregatedEmployeeLinkedAccountsDto } from '@/dtos';
import { LinkedEmployee } from '@/modules/user/user.types';


const QUERY_KEY = 'getLinkedAccountsQueryKey';

const useGetLinkedAccountsQuery = () => {
  const { data, isLoading, isSuccess } = useQuery([QUERY_KEY], () =>
    api.get<IAggregatedEmployeeLinkedAccountsDto[]>(API_URL.EMPLOYEES_LINKED_ACCOUNTS)
  );

  const formattedData = useMemo((): LinkedEmployee[] => {
    if (!data?.data) return [];

    return data?.data?.map(
      (linkedEmployeeResult): LinkedEmployee => ({
        employeeId: toString(linkedEmployeeResult.employee_id),
        enrollmentTitle:
          linkedEmployeeResult?.enrollment_title?.replace(REGEXPS.COMMA_WITHOUT_SPACE, ', ') || '',
        largeLogoUrl: linkedEmployeeResult.large_logo_url || '',
        organizationId: toString(linkedEmployeeResult.organization_id),
        organizationName: linkedEmployeeResult.organization_name || '',
        organizationPath: linkedEmployeeResult.organization_path || '',
        isCreatedByOrphan: linkedEmployeeResult?.is_created_by_orphan,
        completeRegistrationAvailable: linkedEmployeeResult.complete_registration_available || false,
        personId: '',
      })
    );
  }, [data]);

  return {
    formattedData,
    isLoading,
    isSuccess,
  };
};

export default useGetLinkedAccountsQuery;
